import { useState } from 'react';

export function useAssociations(form: any, setAssociationData: any) {
  const [open, setOpen] = useState<boolean>(false);

  const handleClickOpen = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);

  const removeAssociation = (id: any) => {
    const newItems = [...form.values.entityAssociations];
    const index = newItems.findIndex((i) => i.childEntityId === id);
    if (index !== -1) {
      newItems.splice(index, 1);
      form.setFieldValue('entityAssociations', newItems);
      setAssociationData((prev: any) => ({
        ...prev,
        entityAssociations: newItems,
      }));
    }
  };

  return {
    open,    
    handleClickOpen,
    handleCloseDialog,
    removeAssociation,
  };
}
